export default "__VITE_ASSET__U0HfCBPv__";